var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrabber = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 5.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zM10.5 5.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zM6.75 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM10.5 9.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zM6.75 11.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM10.5 13a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrabber);
export default ForwardRef;